import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'
import viewName from '../constant.js'
import {
    Cell,
    Tabs,
    Tab
} from 'vant'
import Swiper from '@/components/swiper/swiper.tpl.vue'
import StoreCard from '@/components/storeCard/storeCard.tpl.vue'
import pageNotFound from '../pageNotFound/index.vue'
import Sku from '@/components/sku/sku.tpl.vue'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import Seckill from '@/components/seckillCard/seckillCard.vue'
import SwiperBox from './components/swiper'
import DeliveryGoodsBox from './components/deliveryGoodsBox'
import SelectedSkuBox from './components/selectedSkuBox'
import GuideBox from './components/guideBox'
import TabsBox from './components/tabsBox'
import onlineCustomerDialog from '@/components/onlineCustomerDialog/onlineCustomerDialog.vue'

import {
    getGoodsInfo,
    getGoodsSpecList
} from '@/models/goodsDetail'

import {
    getAdviceGoodsData
} from '@/models/advice.js'

import {
    setLocalConfig
} from '@/utils/session'
// import {
//     // getLoginInfo
// } from '@/utils/loginInfo'

import {
    wxShare,
} from '@/utils/wxsdk'
// import {toQueryObject} from '@/utils/util'
export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.goodsDetail,
    components: {
        Swiper,
        Cell,
        StoreCard,
        Tabs,
        Tab,
        Sku,
        pageNotFound,
        QualityImg,
        Seckill,
        SwiperBox,
        DeliveryGoodsBox,
        SelectedSkuBox,
        GuideBox,
        TabsBox,
        'online-Dialog': onlineCustomerDialog
    },
    data () {
        return {
            endStatus: 1, // 1: 默认状态 2: 倒计时为0秒 3: 活动已经结束
            seckillTime: '10',
            current_selectedSkuComb: '',
            curWay: 'store', // 默认的提货方式
            initSku: {}, // 初始化sku值
            skus: {}, // 规格参数
            isShowSelectBtn: false, // 是否显示 保养的选择按钮
            tabActive: 0, // tab选择
            // 选中的规格数据，与数量
            selectedSku: {
                num: 1
            },
            // 标签列表 is_proprietary( 0/1, //  1是自营 0是代理) 自营不显示：邮寄到家，显示到店提货
            tags: [{
                name: '邮寄到家',
                show: false
            },
            {
                name: '厂商直接发货',
                show: false
            },
            {
                name: '到店提取现货',
                show: false
            },
            {
                name: '免费安装',
                show: false
            }
            ],
            detailParams: {},
            // 详情页数据
            detail: null,
            isShowPageNot: false,
            sstore_id: '', // 门店id
            isSellOut: false, // 是否已售罄
        }
    },
    watch: {
        detail (val) {
            let tags = this.tags
            tags[0].show = val.delivery_goods.express_status === 1
            tags[1].show = val.goods.is_proprietary === 0
            tags[2].show = val.goods.is_proprietary === 1
            tags[3].show = val.goods.is_free_installation === 1
            this.tags = tags
            this.endStatus = (val.seckill.seckill_status && (val.seckill.seckill_status !== 3)) ? 1 : 3
        },
        $route: {
            handler:function (newRoute) {
                this.detailParams = newRoute.query
                const isAdvice = (this.detailParams.source === 'advice' || this.detailParams.source === 'addGoods' || this.detailParams.source === 'changeGoods')
                this.isShowSelectBtn = isAdvice && this.detailParams.has_history == null
                if (isAdvice) {
                    let advice_href = `${window.location.origin}/#/advice?sstore_id=${this.detailParams.sstore_id}&maintain_id=${this.detailParams.maintain_id}`
                    sessionStorage.setItem('ADVICE_HREF', advice_href)
                }
            },
            immediate: true // 进页面默认触发一次
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin,
            adviceList: ({ advice }) => advice.list, // 保养项目列表
            vehicle_id: ({ advice }) => advice.vehicle_id, // 机型id
        }),
        ...mapGetters([
            'wxUserInfo'
        ]),
        seckillClass () {
            // activity_type_id // 2: 特价活动 3: 特价活动
            // endStatus: 1, // 2: 倒计时为0秒 3: 活动已经结束
            // ico-icon_goodsDetail_58 : 限时秒杀
            // ico-icon_goodsDetail_60 : 本轮已结束
            // ico-icon_goodsDetail_57： 已抢光
            if (Number(this.detail.party.activity_type_id) === 2) { // 特价
                if (this.detail.seckill.seckill_stock > 0) {
                    return { 'ico-icon_goodsDetail_61': true }
                } else if (this.detail.seckill.seckill_stock === 0) {
                    return { 'ico-icon_goodsDetail_57': true }
                }
            } else if (Number(this.detail.party.activity_type_id) === 3) { // 秒杀
                if (this.endStatus === 1 && this.detail.seckill.seckill_stock > 0) {
                    return { 'ico-icon_goodsDetail_58': true }
                } else if (this.endStatus === 2 && this.detail.seckill.seckill_stock > 0) {
                    return { 'ico-icon_goodsDetail_60': true }
                } else if (this.detail.seckill.seckill_stock === 0) {
                    return { 'ico-icon_goodsDetail_57': true }
                }
            }
        },
        // 展示价格
        showPriceStatus () {
            if (this.detail.seckill) {
                let {seckill_status, seckill_stock} = this.detail.seckill
                // 1.当sku正在秒杀时段中时，且秒杀库存≠0时，隐藏此价格；
                // 2.不在秒杀时段，或此时段秒杀库存=0时，展示平常价（正常铺货+正常毛利）；
                if (seckill_status === 2 && seckill_stock > 0) {
                    return 0
                } else if ((seckill_status === 1) || (seckill_status === 2 && seckill_stock === 0)) {
                    return 1
                }
            } else {
                return 1
            }
        },
        startText () {
            const type = Number(this.detail.party.activity_type_id)
            let text = ''
            switch (type) {
            // 特价
            case 2:
                text = '距活动开始'
                break
            // 秒杀
            case 3:
                text = '距下一轮开始'
                break
            }
            return text
        },
        endText () {
            const type = Number(this.detail.party.activity_type_id)
            let text = ''
            switch (type) {
            // 特价
            case 2:
                text = '距活动结束'
                break
            // 秒杀
            case 3:
                text = '距本轮结束'
                break
            }
            return text
        }
    },
    created () {
        this.$setgoindex()
        // 调取，用于通过code获取用户信息并且保存到本地并且进行绑定手机号码的逻辑
        // this.getWxUserInfo(this.$route.query.code || '').then(_ => {
        //     const _thisPath = this.$route.path
        //     let _thisQuery = this.$route.query
        //     _thisQuery['code'] && delete _thisQuery['code'] && this.$router.replace(`${_thisPath}?${toQueryObject(_thisQuery)}`)
        // })
        /* 测试说：进入页面的标题要先置空 */
        this.setPage('')
    },
    mounted () {
        // 保存详情路径到本地存储，GOODSDETAIL
        setLocalConfig('GOODSDETAIL', this.$route.fullPath)
        // console.log(this.path, 'vm.path')
        // let {
        //     marketing_id,
        //     sstore_id,
        //     spu_id,
        //     goods_id,
        //     goods_type
        // } = this.$route.query
        this.detailParams = this.$route.query
        this.render({ ...this.detailParams })
    },
    async activated () {
        if (this.current_selectedSkuComb) {
            let {
                store,
                goods
            } = this.detail
            let selectedSkuComb = this.current_selectedSkuComb
            this.apiDetail({
                sstore_id: store.sstore_id,
                spu_id: selectedSkuComb.spu_id | goods.spu_id,
                goods_id: selectedSkuComb.goods_id || goods.goods_id,
                goods_type: selectedSkuComb.goods_type || goods.goods_type,
                sms_id: this.detailParams.sms_id || '',
                topic_id:this.detailParams.topic_id || '',
            })
        }
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getWxUserInfo',
            'verifyUserInfo',
            'updateAdviceList'
        ]),
        // 微信分享
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    ...detail
                })
            }
        },
        /* 选择该商品 勾选数据 */
        onSelectAdviceGoods () {
            const list = JSON.parse(JSON.stringify(this.adriveList))
            for (let i = 0; i < list.length; i++) {
                const item = list[i]
                if (item.baseItemCode === this.detailParams.baseItemCode) {
                    let project = item['goods']
                    for (let j = 0; j < project.length; j++) {
                        if (project[j].id === this.detailParams.goods_id) {
                            /* 核心 */
                            list[i]['goods'][j].is_selectd = !list[i]['goods'][j].is_selectd
                            break
                        }
                    }
                    break
                }
            }
            this.updateAdviceList(list)
        },
        /**
         * 跳转个人中心
         */
        onToUser () {
            const { activity_id, source } = this.$route.query
            this.$router.push({
                path: '/user',
                query: {
                    activity_id, // 活动id
                    source
                }
            })
        },
        toActivityDetail () {
            if (Number(this.detail.party.activity_type_id) === 2) {
                // this.$router.push(`/marketingDetail?topic_id=${this.detailParams.topic_id}`)
            } else if (Number(this.detail.party.activity_type_id) === 3) {
                this.$router.push(`/seckill?activity_id=${this.detail.seckill.activity_id}&sstore_id=${this.detailParams.sstore_id}`)
            }
        },
        async render (params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.apiDetail(params)
                // 商品下架跳转逻辑
                if (response.errcode === 6003) {
                    // 弹窗提示
                    if (params.marketing_id) {
                        this.$dialog
                            .alert({
                                message: '当前活动已过期'
                            })
                        this.isShowPageNot = true
                    } else {
                        this.$dialog
                            .alert({
                                message: '该商品已下架'
                            }).then(() => {
                                this.$router.go(-1)
                            })
                    }
                } else {
                    if (response.goods && response.goods.is_sell_out === 1) {
                        if (response.goods.new_goods_id) {
                            this.$dialog
                                .alert({
                                    message: `${response.goods.specification.spec_name_1} : ${response.goods.specification.spec_1} 卖光了~ ~`
                                }).then(() => {
                                    this.apiDetail({
                                        marketing_id: '',
                                        sstore_id: params.sstore_id,
                                        spu_id: params.spu_id,
                                        spec_id: response.goods.new_goods_id, // 重新请求返回的规格id商品详情
                                        goods_type: params.goods_type,
                                        sms_id: this.detailParams.sms_id || '',
                                        topic_id: this.detailParams.topic_id || '',
                                    }).then(res => {
                                        this.apiGoodsSpecList(res)
                                    })
                                })
                        } else {
                            this.isSellOut = true
                            this.$dialog
                                .alert({
                                    message: '该商品库存不足'
                                })
                            this.apiGoodsSpecList(response)
                        }
                    } else {
                        this.apiGoodsSpecList(response)
                    }
                }
                resolve(response)
            })
        },
        seckillSuccess () {
            const typeId = Number(this.detail.party.activity_type_id)
            // 秒杀
            if (typeId === 3) {
                if (this.detail.seckill.has_next === 0) {
                    this.endStatus = 3
                } else {
                    this.render({ ...this.detailParams }).then(response => {
                        this.endStatus = 1
                        if (response.seckill.seckill_timestamp >= 0) {
                            this.$refs.seckill.start(String(response.seckill.seckill_timestamp))
                        } else {
                            this.endStatus = 3
                        }
                    })
                }
            } else if (typeId === 2) { // 特价
                this.endStatus = this.detail.seckill.seckill_status !== 3 ? this.detail.seckill.seckill_status : 3
            } else {
                this.endStatus = 3
            }
        },
        // 打开规格
        open () {
            this.$refs.sku.open()
        },
        // 关闭规格
        close () {
            this.$refs.sku.close()
        },
        // 请求详情页
        apiDetail (params, type) {
            this.showLoading()
            return new Promise(async (resolve, reject) => {
                getGoodsInfo(params).then((response) => {
                    Object.assign(this, {
                        seckillTime: String(response.seckill.seckill_timestamp),
                        detail: response
                    })
                    this.setPage(response.goods.goods_name)
                    let shareData = {
                        title: response.share.title, // 分享标题
                        desc: response.share.desc, // 分享描述
                        imgUrl: response.share.imgUrl
                    }
                    this.configWxShare(shareData)
                    this.hideLoading()
                    resolve(response)
                }).catch(res => {
                    resolve(res)
                    this.hideLoading()
                })
            })
        },
        setPage (title) {
            this.$emit('setHeader', {
                title,
                showHeader: true,
                showLeft: true
            })
            this.setAppClass({
                isAppend: false,
                className: 'bgGreyColor'
            })
        },
        // 请求sku规格
        async apiGoodsSpecList (response) {
            let {
                goods,
                store
            } = response
            let skus = await getGoodsSpecList({
                goods_type: goods.goods_type, // 商品类型（proprietary:自营，agent：代理）
                goods_id: goods.goods_id, // 商品规格id
                spu_id: goods.spu_id, // 商品idr
                sstore_id: store.sstore_id, // 门店id
                maintain_id: this.detailParams.maintain_id, // 保养id
            })
            // 初始化sku值用于传入sku组件rr
            this.skus = {
                ...skus
            }

            let img_url = goods.goods_imgs_url[0]

            // 如果是视频就走第二个
            if (img_url.indexOf('mp4') > -1) {
                img_url = goods.goods_imgs_url[1]
            }

            this.initSku = {
                discount: goods.goods_price, // 支付价格
                id: goods.goods_id, // id
                img_url, // 图片
                activity_tag_img: goods.activity_tag_img, // 活动规格图片
                price: goods.goods_original_price, // 原价
                s1: goods.goods_spec[0], // 默认规格
                s2: goods.goods_spec[1], // 默认规格2
                sku_name: goods.goods_name, // 规格名称
                spu_id: goods.spu_id, // 商品id
                stock_num: goods.goods_stock // 库存
            }
        },
        /**
         * 商品切换规格
         */
        async onChangeSku (obj) {
            /* 请求数据：通过规格id查询 兼容保养建议列表的数据 */
            const data = await getAdviceGoodsData({
                sstore_id: this.detailParams.sstore_id,
                goods_type: obj.selectedSkuComb.goods_type,
                goods_id: obj.selectedSkuComb.id, // 商品规格id
                spu_id: obj.selectedSkuComb.spu_id, // 商品id
                vehicle_id: this.vehicle_id // 车型id
            })

            /* 获取新的当前选中的数据（已选规格） */
            const nowItem = Object.assign(data, {
                is_selectd: 1,
                selected_num: obj.selectedNum
            })

            /* 更新 vuex的数据 */
            this.upData(nowItem)
        },
        /**
         * 更新数据
         */
        upData (nowItem) {
            const list = JSON.parse(JSON.stringify(this.adviceList))
            const { source, baseItemCode, now_id, goods_id } = this.detailParams
            for (let i = 0; i < list.length; i++) {
                const item = list[i]
                if (item.baseItemCode === baseItemCode) {
                    let project = item['goods']
                    if (source === 'changeGoods' || source === 'advice') {
                        /* 当前选中要替换的子节点id */
                        for (let j = 0; j < project.length; j++) {
                            /* 默认读url上面的 goods_id */
                            let _id = goods_id
                            /* 如果是从添加商品换切换商品页面进来的 */
                            if (source === 'changeGoods') {
                                _id = now_id
                            }
                            if (project[j].id === _id) {
                                /* 核心 */
                                list[i]['goods'][j] = nowItem
                                break
                            }
                        }
                    } else if (source === 'addGoods') {
                        /* push一个新的子节点 */
                        project.push(nowItem)
                    }
                }
            }

            /* 更新vuex */
            this.updateAdviceList(list)
            this.$refs.sku.close()
            /* 返回上一页 */
            if (source === 'addGoods' || source === 'changeGoods') {
                this.$router.go(-2)
            } else {
                this.$router.go(-1)
            }
        },
        // 确认
        confirm (e) {
            const sourceArr = [
                'advice',
                'addGoods',
                'changeGoods'
            ]
            /* 保养建议逻辑 */
            if (sourceArr.includes(this.detailParams.source)) {
                this.onChangeSku(e)
                return
            }

            if (this.skus.sku.none_sku === 1) {
                let {
                    selectedSkuComb
                } = e
                let {
                    goods_id,
                    spu_id,
                    is_proprietary
                    // goods_type
                } = this.detail.goods
                let {
                    sstore_id
                } = this.detail.store
                if (Number(selectedSkuComb.id) !== Number(goods_id)) {
                    // 重新请求数据
                    this.apiDetail({
                        sstore_id: sstore_id,
                        spu_id: spu_id,
                        goods_id: selectedSkuComb.goods_id,
                        goods_type: is_proprietary === 1 ? 'proprietary' : 'agent',
                        sms_id: this.detailParams.sms_id || '',
                        topic_id: this.detailParams.topic_id || '',
                        page_code: this.detailParams.page_code || '',
                    }, 'buyNow')
                }
                this.close()
            } else {
                this.close()
            }
        },
        // 立即购买
        buyNowToOrder (e) {
            let {
                selectedNum,
                selectedSkuComb
            } = e

            this.verifyUserInfo({
                type: 'back'
            }).then(_ => {
                // 判断是否有商品数量
                if (selectedSkuComb) {
                    // 保存数据
                    this.setGoodsDetaStorage(selectedNum, selectedSkuComb)
                    this.$router.push({
                        name: 'confirmOrder'
                    })

                    if (this.skus.sku.none_sku === 1) {
                        this.current_selectedSkuComb = selectedSkuComb
                    }
                }
            })
        },
        // navigation () {

        // },
        // 验证手机号码流程
        // verify () {
        //   this.verifyUserInfo()
        // return new Promise((resolve, reject) => {
        //     if (getLoginInfo()['token']) {
        //         resolve()
        //     } else {
        //         // 判断是否微信环境
        //         if (this.isWeixin) {
        //             // 1. 判断是否有用户信息

        //             if (this.wxUserInfo) {
        //                 // 判断是否有绑定过手机号码
        //                 if (this.wxUserInfo.phone_number) {
        //                     // 进入购买流程
        //                     resolve()
        //                 } else {
        //                     // 进入绑定手机号码页面流程、
        //                     this.$router.push({
        //                         name: 'bindingPhone'
        //                     })
        //                 }
        //             } else {
        //                 // 跳转去授权页
        //                 this.$dialog
        //                     .alert({
        //                         message: '请授权登录',
        //                         closeOnClickOverlay: true
        //                     }).then(() => {
        //                         location.href = wxConfig()
        //                     }).catch(() => {

        //                     })
        //             }
        //             // 2. 如果没有绑定过，则跳去绑定手机号的环
        //         } else {
        //             this.$router.push({
        //                 name: 'login'
        //             })
        //             // 判断是否有token
        //         }
        //     }
        // })
        // },
        // 设置存放订单数据
        setGoodsDetaStorage (selectedNum, selectedSkuComb) {
            // const { curWay } = this
            const {
                store,
                goods
            } = this.detail
            setLocalConfig('CONFIRM_ORDER', {
                // expressStatus: delivery_goods.express_status === 1,
                // curWay, // 默认的提货方式
                marketing_id: this.$route.query.marketing_id,
                sstore_id: store.sstore_id, // 门店id
                goods: [{
                    goods_id: selectedSkuComb.id || goods.goods_id,
                    goods_type: selectedSkuComb.goods_type || goods.goods_type,
                    quantity: selectedNum
                }],
                sms_id: this.detailParams.sms_id || '',
                topic_id: this.detailParams.topic_id || '',
                page_code: this.detailParams.page_code || '',
            })
        },
        // 展示免费安装提示信息
        showOperateTips () {
            this.$dialog.alert({
                message: '仅包含按正规操作流程安装本商品时的安装服务费用'
            })
        }
    },
    destroyed () {
        this.hideLoading()
    },
    beforeRouteLeave (to, from, next) {
        // 设置下一个路由的meta
        // 如果页面是specialActivity或者marketingDetail是不关闭缓存
        // if (to.name === 'specialActivity' || to.name === 'marketingDetail') {
        //     next()
        // } else {
        //     if (to.name === 'seckill') {
        //         from.meta.keepAlive = false
        //     } else if (to.name === 'advice') {
        //         to.meta.keepAlive = true
        //         from.meta.keepAlive = false
        //     } else {
        //         to.meta.keepAlive = false
        //     }
        //     next()
        // }
        next(vm => {
            vm.path = from.path
        })
    }
}
